<template>
  <div class="map" ref="skimap"></div>
</template>

<script>
import { Loader, LoaderOptions } from "google-maps";

export default {
  name: "Skimap",
  data: function () {
    return {
      google: null,
      map: null,
      skimapId: "",
    };
  },
  props: {
    skimap_url: {
      required: false,
      type: String,
    },
    skimap_id: {
      default: "strediska/84",
      required: false,
      type: String,
    },
    autoinitialized: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  mounted: function () {
    this.skimapId = this.skimap_id;

    if (this.autoinitialized) {
      this.initializeSkimap();
    }

    this.$root.$on("setSkimap", (data) => {
      this.skimapId = data;
      this.initializeSkimap();
    });
  },
  methods: {
    getNormalizedCoord: function (coord, zoom) {
      var y = coord.y;
      var x = coord.x;

      var tileRange = 1 << zoom;

      if (y < 0 || y >= tileRange) {
        return null;
      }
      if (x < 0 || x >= tileRange) {
        return null;
      }

      x = x - Math.floor(x / tileRange) * tileRange;

      return { x: x, y: y };
    },
    isHigherThenViewport: function (leftTop, rightBottom, map, $map) {
      var mapHeight = getDistanceInPx(
        map,
        new google.maps.LatLng(leftTop.lat, leftTop.lng),
        new google.maps.LatLng(rightBottom.lat, leftTop.lng),
        map.getZoom()
      );
      var mapViewportHeight = $map.parent().outerHeight();
      return mapHeight > mapViewportHeight;
    },
    getDistanceInPx: function (map, position1, position2, zoom) {
      var p1 = map.getProjection().fromLatLngToPoint(position1);
      var p2 = map.getProjection().fromLatLngToPoint(position2);

      var pixelSize = Math.pow(2, -zoom);

      var distance =
        Math.sqrt(
          (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y)
        ) / pixelSize;

      return distance;
    },
    initializeSkimap: async function () {
      const tileSize = 256;
      const skimapUrl = this.skimap_url;
      const skimapId = this.skimapId;
      const tilesUrl = skimapUrl + skimapId + "/";
      let mapElement = this.$refs["skimap"];
      var _this = this;

      if (this.google === null && this.map === null) {
        const options = {
          libraries: ["places", "geometry"],
          language: "CZ",
          version: 3.31,
        };
        const loader = new Loader(
          "AIzaSyAZB5jLl6qMCHG49UEM8XZS4qBx1-xWOLM",
          options
        );
        var mapOptions = {
          center: { lat: 0, lng: 0 },
          zoom: 3,
          minZoom: 1,
          maxZoom: 4,
          streetViewControl: false,
          mapTypeControl: false,
        };

        this.google = await loader.load();
        this.map = new this.google.maps.Map(mapElement, mapOptions);

        /*dataLayer.push({
                        event: 'trackEvent',
                        eventCategory: 'googleMapsSki',
                        eventAction: 'googleMapsLoad',
                        eventValue: 1
                    });*/
      }

      var skiMapType = new this.google.maps.ImageMapType({
        getTileUrl: function (coord, zoom) {
          var normalizedCoord = _this.getNormalizedCoord(coord, zoom);
          if (!normalizedCoord) {
            return null;
          }
          return (
            tilesUrl +
            zoom +
            "/" +
            normalizedCoord.x +
            "_" +
            normalizedCoord.y +
            ".jpg"
          );
        },
        tileSize: new _this.google.maps.Size(tileSize, tileSize),
        maxZoom: 4,
        minZoom: 1,
        name: "ski",
      });

      this.map.mapTypes.set("ski", skiMapType);
      this.map.setMapTypeId("ski");

      var mapSize = {
        width: mapElement.offsetWidth,
        height: mapElement.offsetHeight,
      };
      var smallestEdge = Math.min(mapSize.width, mapSize.height);
      var maxTilesToRow = Math.floor(smallestEdge / tileSize);
      // var newZoom = 0;
      // if (maxTilesToRow > 1) {
      //   newZoom = Math.floor(Math.sqrt(maxTilesToRow));
      // }
      // this.map.setZoom(newZoom);
    },
  },
};
</script>

<style scoped>
.map {
  width: 100%;
  height: 100%;
}
</style>
